import React from 'react';
import {Card, Typography, CardContent, CardActions, Grid, Paper } from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import InfoVerificacionCheque from './InfoVerificacionCheque';

import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';




const useStyles = makeStyles((theme)=>({
    root: {
        textAlign: 'center',        
        justifyContent: 'center',
        backgroundColor: theme.palette.greyFondo.main,       
        marginTop: theme.spacing(2),  
        marginBottom: theme.spacing(2)
    },
    texto: {
        fontSize: 18,
        color: 'dark',
        fontWeight: 'bold',
        
    },
    titulo: {        
        fontSize: 15,
        color: 'dark',
    },


}));

const Cards = ({titulo, dato}) => {

    const classes = useStyles();

    return ( 
        <div>
        <Card className={classes.root}  elevation={4}>
            
            <CardContent  >
          
                <Typography className={classes.titulo} >
                    {titulo}
                </Typography>
                <Typography className={classes.texto}>
                    {dato}
                </Typography>                                
            </CardContent>
            
        </Card>
        </div>
     );
}
 
export default Cards;